/**
 * 版本类型
 * @type {{ALL: 1, INTERVAL: 2, SPECIFIC: 3}}
 */
export const VERSION_TYPE = {
  // 全部版本
  ALL: 1,
  // 版本区间
  INTERVAL: 2,
  // 指定版本
  SPECIFIC: 3,
}

/**
 * 版本类型列表
 */
export const VERSION_TYPE_LIST = [
  {
    value: VERSION_TYPE.ALL,
    label: '全部版本'
  },
  {
    value: VERSION_TYPE.INTERVAL,
    label: '版本区间'
  },
  {
    value: VERSION_TYPE.SPECIFIC,
    label: '指定版本'
  }
]

/**
 * 格式化TV版本号显示
 * @param {object} row - 列表项对象
 * @returns {array} 格式化后的版本号显示文本数组；['tv版本', '特殊版本']
 */
export function getVersionConfigText (row) {
  /**
   * tvVersionType 版本类型：1-全部版本，2-版本区间，3-指定版本;
   * tvVersion 版本号值
   * regexTvVersion 特殊版本号
   */
  const { tvVersionType, tvVersion, regexTvVersion } = row;

  const formatInterval = (versionRange) => {
    if (!versionRange) return "";

    const [minVersion, maxVersion] = versionRange.split(",");
    const conditions = [];

    if (minVersion) conditions.push(`>=${minVersion}`);
    if (maxVersion) conditions.push(`<=${maxVersion}`);

    return conditions.join(",");
  };

  // 获取特殊版本号
  const specialText = regexTvVersion ? `特殊: ${regexTvVersion}` : '';

  const formatMap = {
    [VERSION_TYPE.ALL]: ["全部版本"],
    [VERSION_TYPE.INTERVAL]: [formatInterval(tvVersion), specialText],
    [VERSION_TYPE.SPECIFIC]: [tvVersion]
  };

  return formatMap[tvVersionType] || [];
}

/**
 * tv版本号处理
 * @param {number} type - tv版本号类型
 * @param {string} value - tv版本号值
 * @param {string} extra - 额外参数(特殊正则)
 * @returns {object} tv版本号处理结果
 */
export function tvVersionHandle(type, value, extra) {
  const initialValue = {
    tvVersionMin: "",
    tvVersionMax: "",
    tvVersionSpecified: "",
    regexTvVersion: ""
  };
  if (type === VERSION_TYPE.INTERVAL) {
    const parts = value.split(",");
    const min = parts[0] || "";
    const max = parts[1] || "";
    return {
      ...initialValue,
      tvVersionMin: min,
      tvVersionMax: max,
      regexTvVersion: extra,
    };
  } else if (type === VERSION_TYPE.SPECIFIC) {
    return {
      ...initialValue,
      tvVersionSpecified: value,
    };
  } else {
    return {
      ...initialValue
    };
  }
}

/**
 * tv版本号拼接处理
 * @param params
 * @returns { tvVersion: string, regexTvVersion: string } tv版本号拼接处理结果
 */
export function tvVersionJoinHandler(params) {
  if (params.tvVersionType === VERSION_TYPE.INTERVAL) {
    return {
      tvVersion: `${params.tvVersionMin || ""},${params.tvVersionMax || ""}`,
      regexTvVersion: params.regexTvVersion
    };
  } else if (params.tvVersionType === VERSION_TYPE.SPECIFIC) {
    return {
      tvVersion: params.tvVersionSpecified,
      regexTvVersion: ""
    };
  }

  return {
    tvVersion: "",
    regexTvVersion: ""
  }
}
